/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Changesorupdatestoyou4Inputs */

const en_settings_changesorupdatestoyou4 = /** @type {(inputs: Settings_Changesorupdatestoyou4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes or updates to your profile must be done by a member of the tech team. Reach out at`)
};

/**
* | output |
* | --- |
* | "Changes or updates to your profile must be done by a member of the tech team. Reach out at" |
*
* @param {Settings_Changesorupdatestoyou4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_changesorupdatestoyou4 = /** @type {((inputs?: Settings_Changesorupdatestoyou4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Changesorupdatestoyou4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_changesorupdatestoyou4(inputs)
});
export { settings_changesorupdatestoyou4 as "settings_changesOrUpdatesToYou" }